import {Box, Chip, Divider, FormControl, FormLabel} from "@mui/material";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalRadio from "../../global-fields/GlobalRadio";
import GlobalTextField from "../../global-fields/GlobalTextField";
import {useFormik} from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import plusIcon from "../../../assets/img/proposal-img/plus_icon.svg";
import minusIcon from "../../../assets/img/proposal-img/minus_icon.svg";
import {MANDATORY_QUES} from "../../../constants/constants";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {PROPOSAL_FORM} from "../../../constants/apiConstant";
import {setUiData} from "../../../store/uiSlice";
import {
  areRequiredFieldsFilled,
  initialFormValidations,
  parseToNumber,
  removeCookies,
  USD_FORMATTER,
} from "../../../constants/helper";
import {useNavigate} from "react-router-dom";
import {motion} from "framer-motion";
import {fadeSlideIn} from "../../../constants/motionConstants";
import GlobalYearField from "../../global-fields/GlobalYearField";
import {amountSchemaWithoutRequired} from "../../../constants/validationSchemas";
import GlobalSelectField from "../../global-fields/GlobalSelectField";
import dayjs from "dayjs";

const LossTypeMenuItems = [
  {name: "Mysterious Disappearance", value: "Mysterious Disappearance"},
  {name: "⁠Shipping", value: "⁠Shipping"},
  {name: "⁠Travel", value: "⁠Travel"},
  {name: "⁠Burglary", value: "⁠Burglary"},
  {name: "⁠Robbery", value: "⁠Robbery"},
  {name: "Other", value: "Other"},
];

const StepTwoForm = ({leftGridWidth}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user, selectedClient} = useSelector(selectAuthState);
  const {
    proposalStep,
    propStep2Data,
    proposal_id,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
  } = useSelector(selectDataStoreState);
  const lossFieldsLimit = 20;
  const [disableDraft, setDisableDraft] = useState(false);

  const handleStepData = (e) => {
    if (!proposal_id) {
      GlobalNotificationPopup({
        type: "error",
        message: "Please Fillout Initial/Business Details Form First.",
      });
      return;
    }
    dispatch(
      setUiData({
        showLoader: true,
      })
    );
    let cleanedData = {...e};

    // Clean the losses array if present
    if (Array.isArray(cleanedData.losses)) {
      cleanedData.losses = cleanedData.losses.map((loss) => ({
        ...loss,
        amount: parseToNumber(loss.amount),
        amount_insured: parseToNumber(loss.amount_insured),
        year: dayjs(loss.year).format("YYYY"),
      }));
    }
    // console.log("cleanedData",cleanedData);
    // return;
    let data = {
      ...cleanedData,
      user_id: user?.id,
      proposal_id,
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
    };
    if (user?.user_type === "agent") {
      data = {...data, user_id: selectedClient?.user_id, agent_id: user?.id};
    }

    const options = {
      method: PROPOSAL_FORM.method,
      headers: PROPOSAL_FORM.headers,
      body: JSON.stringify(data),
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          formik.resetForm();
        } else if (res.status == 1) {
          formik.resetForm();
          dispatch(
            setDataStore({
              proposalStep: proposalStep + 1,
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
        if (e?.save_draft) {
          setDisableDraft(false);
        }
      })
      .catch((error) => {
        dispatch(
          setDataStore({
            proposalStep: 1,
            proposal_id: null,
            previous_proposal_id: null,
            editingSubmitted: false,
            clickedSteps: [],
            formValidations: initialFormValidations,
          })
        );
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik.resetForm();
      });
  };
  const propStep2DataMemoize = useMemo(() => propStep2Data, [propStep2Data]);

  const InitialLossArr = [
    {
      year: "",
      type: "",
      amount: "",
      amount_insured: "",
    },
  ];

  const initialValues = {
    step: 2,
    any_losses:
      propStep2DataMemoize?.any_losses === "1" ||
      propStep2DataMemoize?.any_losses === 1
        ? 1
        : 0,
    losses:
      propStep2DataMemoize?.losses?.length > 0
        ? propStep2DataMemoize.losses.map((item) => ({
            ...item,
            amount:
              item.amount == 0 || item.amount == "0" || item.amount
                ? USD_FORMATTER.format(item.amount)
                : "",
            amount_insured:
              item.amount_insured == 0 ||
              item.amount_insured == "0" ||
              item.amount_insured
                ? USD_FORMATTER.format(item.amount_insured)
                : "",
          }))
        : null,

    insurer_cancel:
      propStep2DataMemoize?.insurer_cancel === "Yes"
        ? propStep2DataMemoize?.insurer_cancel
        : "No",
    reason: propStep2DataMemoize?.reason ?? null,
    detailed_stock:
      propStep2DataMemoize?.detailed_stock == "0" ||
      propStep2DataMemoize?.detailed_stock == 0
        ? 0
        : 1,
    physical_stock: propStep2DataMemoize?.physical_stock ?? null,
    secure_alliance_member:
      propStep2DataMemoize?.secure_alliance_member === "1" ||
      propStep2DataMemoize?.secure_alliance_member === 1
        ? 1
        : 0,
    secure_alliance_member_reason:
      propStep2DataMemoize?.secure_alliance_member_reason ?? null,
  };

  // useEffect(() => {
  //   if (propStep2DataMemoize) {
  //     formik.setValues(initialValues);
  //   }
  // }, [propStep2DataMemoize]);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      any_losses: Yup.string(),
      // losses: Yup.array().of(
      //   Yup.object()
      //     .shape({
      //       year: Yup.string().required(MANDATORY_QUES).nullable(),
      //       type: Yup.string().required(MANDATORY_QUES).nullable(),
      //       amount: amountSchemaWithoutRequired,
      //       amount_insured: amountSchemaWithoutRequired,
      //     })
      //     .when("any_losses", {
      //       is: (val) => val === "1" || val === 1,
      //       then: (schema) =>
      //         schema.required(
      //           `Losses are required when "Any Loss in past" is Yes.`
      //         ),
      //       otherwise: (schema) => schema.notRequired().nullable(),
      //     })
      // ),
      losses: Yup.array()
        .of(
          Yup.object().shape({
            year: Yup.string().required(MANDATORY_QUES).nullable(),
            type: Yup.string().required(MANDATORY_QUES).nullable(),
            amount: amountSchemaWithoutRequired,
            amount_insured: amountSchemaWithoutRequired,
          })
        )
        .when("any_losses", {
          is: (val) => val === "1" || val === 1,
          then: (schema) =>
            schema.min(1, "At least one loss entry is required.").required(),
          otherwise: (schema) => schema.notRequired().nullable(), // Must allow null
        }),
      insurer_cancel: Yup.string().required(MANDATORY_QUES),
      reason: Yup.string().when("insurer_cancel", {
        is: "Yes",
        then: (schema) =>
          schema.required(
            "Reason is required when canceled or refused is Yes."
          ),
        otherwise: (schema) => schema.nullable(),
      }),
      detailed_stock: Yup.string().required(MANDATORY_QUES),
     // physical_stock: Yup.string().required(MANDATORY_QUES),
      secure_alliance_member: Yup.string().required(MANDATORY_QUES),
      secure_alliance_member_reason: Yup.string().when(
        "secure_alliance_member",
        {
          is: (val) => val === "1" || val === 1,
          then: (schema) =>
            schema.required(
              `Required when "Member of the Jewelers Security Alliance is Yes."`
            ),
          otherwise: (schema) => schema.nullable(),
        }
      ),
    }),
    onSubmit: (values) => {
      //console.log("Form submitted 2:", values);
      handleStepData(values);
    },
  });

  const handlePlus = useCallback(() => {
    const lastLoss = formik.values.losses[formik.values.losses.length - 1];

    if (
      !lastLoss.year ||
      !lastLoss.type
      //||
      // !lastLoss.amount ||
      // !lastLoss.amount_insured
    ) {
      GlobalNotificationPopup({
        type: "warning",
        message: "Year and Type fields required before adding a new entry.",
      });
      return;
    }

    if (formik.values.losses.length >= lossFieldsLimit) return;

    formik.setFieldValue("losses", [
      ...formik.values.losses,
      {year: "", type: "", amount: "", amount_insured: ""},
    ]);
  }, [formik.values.losses]);

  const handleMinus = useCallback(
    (index) => {
      if (formik.values.losses.length === 1) return;

      const newLosses = [...formik.values.losses];
      newLosses.splice(index, 1);
      formik.setFieldValue("losses", newLosses);
    },
    [formik.values.losses]
  );

  const handleAmountFieldChangeOLD = (e, index, fieldName) => {
    const rawValue = e.target.value;
    const numericValue = parseToNumber(rawValue);
    //console.log("numericValue", rawValue, numericValue, USD_FORMATTER.format(numericValue));
    // Format the value back to currency format for display
    formik.setFieldValue(
      fieldName,
      numericValue !== "" ? USD_FORMATTER.format(numericValue) : ""
    );
  };

  const handleAmountFieldChange = (e, index, fieldName) => {
    let rawValue = e.target.value;

    // Ensure it always starts with $
    if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

    // Extract numeric part
    const numericValue = parseToNumber(rawValue);

    // Allow typing "$" or "$." without formatting
    if (rawValue === "$" || rawValue === "$.") {
      formik.setFieldValue(fieldName, rawValue);
      return;
    }

    // Format integer part with commas, keep decimal part as typed
    let formatted = "$";
    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");

      // Format integer with commas
      formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));

      // Append decimal part if exists, limit to 2 digits
      if (decimalPart !== undefined) {
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    formik.setFieldValue(fieldName, formatted);
  };
  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 2) {
          return {...item, status: 2};
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };

  const handleSaveDraft = useCallback(() => {
    const {values} = formik;
    setDisableDraft(true);
    let vals = {...values, save_draft: true};
    // console.log("vals", vals);
    //return;
    handleStepData(vals);
  }, [formik]);
  //console.log("formik", formik.values);
  // console.log("formik", propStep2DataMemoize,formik.dirty, formik.values, formik.errors);
  // // console.log("!formik.dirty && propStep2DataMemoize !== null",!formik.dirty && propStep2DataMemoize !== null,formik.dirty,propStep2DataMemoize)
  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            {selectedClient !== null ? (
              <div className={style.client_title}>
                <p> On behalf of Client : </p>
                <h3>
                  {selectedClient?.first_name} {selectedClient?.last_name}{" "}
                </h3>
                {/* <span>{selectedClient?.email} </span> */}
                <Divider />
              </div>
            ) : null}
            <h2 className={style.propo_title}>Past Experiences</h2>
            <form
              onSubmit={handleCustomSubmit}
              autoComplete="false"
              autoSave="false"
            >
              <Grid container spacing={2}>
                <Grid size={{xs: 12, md: 12}}>
                  <h2 className={style.formTitleh2}>4) Losses</h2>
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                  <h3 className={style.htitleText}>
                    Have you had any losses in the past?
                  </h3>
                  <Grid container spacing={2} sx={{mt: 2}}>
                    <Grid size={{xs: 12, md: 6}}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.any_losses == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          // formik.setFieldValue("any_losses",true);
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            any_losses: 1,
                            losses: InitialLossArr,
                          }));
                        }}
                        // error={
                        //   formik.touched.insurer_cancel &&
                        //   Boolean(formik.errors.insurer_cancel)
                        // }
                        // errorText={
                        //   formik.touched.insurer_cancel &&
                        //   formik.errors.insurer_cancel
                        // }
                      />
                    </Grid>
                    <Grid size={{xs: 12, md: 6}}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.any_losses == 0}
                        onClick={(e) => {
                          e.preventDefault();
                          // formik.setFieldValue("any_losses", false);
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            any_losses: 0,
                            losses: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {formik.values.any_losses == 1 ? (
                  <>
                    <Grid size={{xs: 12, md: 12}}>
                      <div className={style.plusIconMain}>
                        <h3 className={style.htitleText}>
                          Losses (of proposer and any associated companies for
                          the past 5 years) *
                        </h3>

                        <div
                          className={
                            style.plusImgMain + " " + style.plusImgWidth
                          }
                        >
                          {/* Add Icon - Show only at index 0 and if the limit is not exceeded */}
                          {formik.values?.losses?.length < lossFieldsLimit && (
                            <p
                              style={{
                                position: "inherit",
                                display: "flex",
                              }}
                              onClick={handlePlus}
                            >
                              <img
                                src={plusIcon}
                                alt="Add"
                                style={{marginRight: "5px"}}
                              />
                              Add
                            </p>
                          )}
                        </div>
                      </div>
                    </Grid>
                  </>
                ) : null}
              </Grid>
              {formik.values.any_losses == 1 &&
                formik.values?.losses?.map((loss, index) => {
                  return (
                    <Grid container spacing={2} key={index} sx={{mt: 2}}>
                      {index !== 0 && (
                        <Box sx={{width: "100%", mt: 1, mb: 1}}>
                          <Divider sx={{position: "relative"}}>
                            <Chip
                              label={`${index + 1}`}
                              size="medium"
                              clickable
                              onDelete={() => handleMinus(index)}
                            />
                          </Divider>
                        </Box>
                      )}
                      <Grid size={{xs: 12, md: 3}}>
                        <FormControl fullWidth>
                          <FormLabel sx={{mb: 1}}> Year * </FormLabel>
                        </FormControl>
                        {/* <GlobalTextField
                        type="number"
                        value={formik.values.losses[index]?.year}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id={`losses.${index}.year`}
                        name={`losses.${index}.year`}
                        error={
                          formik.touched.losses?.[index]?.year &&
                          Boolean(formik.errors.losses?.[index]?.year)
                        }
                        helperText={
                          formik.touched.losses?.[index]?.year &&
                          formik.errors.losses?.[index]?.year
                        }
                      /> */}
                        <GlobalYearField
                          value={formik.values?.losses?.[index]?.year}
                          onChange={(newValue) => {
                            formik.setFieldValue(
                              `losses[${index}].year`,
                              newValue
                            );
                          }}
                          onBlur={() =>
                            formik.setFieldTouched(
                              `losses[${index}].year`,
                              true
                            )
                          }
                          id={`losses.${index}.year`}
                          name={`losses[${index}].year`}
                          error={
                            formik.touched?.losses?.[index]?.year &&
                            Boolean(formik.errors?.losses?.[index]?.year)
                          }
                          helperText={
                            formik.touched?.losses?.[index]?.year &&
                            formik.errors?.losses?.[index]?.year
                          }
                          clearBtn={formik.values?.losses?.[index]?.year !== ""}
                        />
                      </Grid>
                      <Grid size={{xs: 12, md: 3}}>
                        <FormControl fullWidth>
                          <FormLabel sx={{mb: 1}}>Loss Type *</FormLabel>
                        </FormControl>
                        {/* <GlobalTextField
                        type="text"
                        value={formik.values.losses[index]?.type}
                        onChange={formik.handleChange}

                        onBlur={formik.handleBlur}
                        id={`losses.${index}.type`}
                        name={`losses.${index}.type`}
                        error={
                          formik.touched.losses?.[index]?.type &&
                          Boolean(formik.errors.losses?.[index]?.type)
                        }
                        helperText={
                          formik.touched.losses?.[index]?.type &&
                          formik.errors.losses?.[index]?.type
                        }
                      /> */}
                        <GlobalSelectField
                          labelId={`losses[${index}].type`}
                          id={`losses.${index}.type`}
                          value={formik.values.losses[index]?.type}
                          name={`losses.${index}.type`}
                          onChange={(e) =>
                            formik.setFieldValue(
                              `losses.${index}.type`,
                              e.target.value
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.losses?.[index]?.type &&
                            Boolean(formik.errors.losses?.[index]?.type)
                          }
                          helperText={
                            formik.touched.losses?.[index]?.type
                              ? formik.errors.losses?.[index]?.type
                              : ""
                          }
                          placeH={"Select"}
                          menuItems={LossTypeMenuItems}
                        />
                      </Grid>
                      <Grid size={{xs: 12, md: 3}}>
                        <FormControl fullWidth>
                          <FormLabel sx={{mb: 1}}> Amount</FormLabel>
                        </FormControl>
                        <GlobalTextField
                          type="text"
                          placeH={"$"}
                          value={formik.values.losses[index]?.amount}
                          //onChange={formik.handleChange}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              index,
                              `losses.${index}.amount`
                            )
                          }
                          onBlur={formik.handleBlur}
                          id={`losses.${index}.amount`}
                          name={`losses.${index}.amount`}
                          error={
                            formik.touched.losses?.[index]?.amount &&
                            Boolean(formik.errors.losses?.[index]?.amount)
                          }
                          helperText={
                            formik.touched.losses?.[index]?.amount &&
                            formik.errors.losses?.[index]?.amount
                          }
                        />
                      </Grid>
                      <Grid size={{xs: 12, md: 3}}>
                        <div className={style.plusIconMain}>
                          <div style={{width: "100%"}}>
                            <FormControl fullWidth>
                              <FormLabel sx={{mb: 1}}>Amount Insured</FormLabel>
                            </FormControl>
                            <GlobalTextField
                              type="text"
                              placeH={"$"}
                              value={
                                formik.values.losses[index]?.amount_insured
                              }
                              onChange={(e) =>
                                handleAmountFieldChange(
                                  e,
                                  index,
                                  `losses.${index}.amount_insured`
                                )
                              }
                              onBlur={formik.handleBlur}
                              id={`losses.${index}.amount_insured`}
                              name={`losses.${index}.amount_insured`}
                              error={
                                formik.touched.losses?.[index]
                                  ?.amount_insured &&
                                Boolean(
                                  formik.errors.losses?.[index]?.amount_insured
                                )
                              }
                              helperText={
                                formik.touched.losses?.[index]
                                  ?.amount_insured &&
                                formik.errors.losses?.[index]?.amount_insured
                              }
                            />
                          </div>
                          {/* <div className={style.plusImgMain}> */}
                          {/* {index + 1 === lossFieldsLimit ? (
                                                        <p onClick={() => handleMinus(index)}>
                                                            <img src={minusIcon} />
                                                        </p>
                                                    ) : index + 1 === totalPastYrs.length ? (
                                                        <p onClick={handlePlus}>
                                                            <img src={plusIcon} />
                                                        </p>
                                                    ) : (
                                                        <p onClick={() => handleMinus(index)}>
                                                            <img src={minusIcon} />
                                                        </p>
                                                    )} */}
                          {/* 
                                                    {index + 1 !== formik.values.losses.length ? (
                                                        <p onClick={() => handleMinus(index)}>
                                                            <img src={minusIcon} />
                                                        </p>
                                                    ) : (
                                                        <p onClick={handlePlus}>
                                                            <img src={plusIcon} />
                                                        </p>
                                                    )} */}
                          {/* Minus Icon (Remove current row) */}
                          {/* {formik.values.losses.length > 1 && (
                              <p onClick={() => handleMinus(index)}>
                                <img src={minusIcon} alt="minus" />
                              </p>
                            )} */}

                          {/* Plus Icon (Add a new row) */}
                          {/* {index === formik.values.losses.length - 1 && (
                              <p onClick={handlePlus}>
                                <img src={plusIcon} alt="add" />
                              </p>
                            )}
                          </div> */}
                        </div>
                      </Grid>
                    </Grid>
                  );
                })}

              <Grid container spacing={2} sx={{mt: 1}}>
                <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                  <h2 className={style.formTitleh2}>
                    5) Past Insurance History
                  </h2>
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                  <h3 className={style.htitleText}>
                    {/* Any insurer ever canceled or refused? */}
                    Has any insurer ever canceled or declined to provide
                    coverage?
                  </h3>
                  <Grid container spacing={2} sx={{mt: 2}}>
                    <Grid size={{xs: 12, md: 6}}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.insurer_cancel === "Yes"}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("insurer_cancel", "Yes");
                        }}
                        error={
                          formik.touched.insurer_cancel &&
                          Boolean(formik.errors.insurer_cancel)
                        }
                        errorText={
                          formik.touched.insurer_cancel &&
                          formik.errors.insurer_cancel
                        }
                      />
                    </Grid>
                    <Grid size={{xs: 12, md: 6}}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.insurer_cancel === "No"}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            insurer_cancel: "No",
                            reason: "",
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {formik.values.insurer_cancel === "Yes" ? (
                  <Grid size={{xs: 12, md: 6}}>
                    <h3 className={style.htitleText}>
                      {/* Please do specify reason */}
                      Please specify the reason *
                    </h3>
                    <Grid container spacing={2}>
                      <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                        <GlobalTextField
                          type="text"
                          placeH={
                            formik.values?.insurer_cancel === "No"
                              ? "No insurer Ever Canceled/Refused."
                              : ""
                          }
                          value={formik.values.reason}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          id="reason"
                          name="reason"
                          error={
                            formik.touched.reason &&
                            Boolean(formik.errors.reason)
                          }
                          helperText={
                            formik.touched.reason && formik.errors.reason
                          }
                          disabled={formik.values?.insurer_cancel === "No"}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>

              <Grid container spacing={2} sx={{mt: 1}}>
                <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                  <h2 className={style.formTitleh2}>6) Bookkeeping</h2>
                </Grid>
                <Grid size={{xs: 12, md: 8, xl: 6}}>
                  <h3 className={style.htitleText}>
                    Do you keep a detailed stock record by nature of stock and
                    value?
                  </h3>
                  <Grid container spacing={2} sx={{mt: 2}}>
                    <Grid size={{xs: 12, md: 6}}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.detailed_stock == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("detailed_stock", "1");
                        }}
                        error={
                          formik.touched.detailed_stock &&
                          Boolean(formik.errors.detailed_stock)
                        }
                        errorText={
                          formik.touched.detailed_stock &&
                          formik.errors.detailed_stock
                        }
                      />
                    </Grid>
                    <Grid size={{xs: 12, md: 6}}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.detailed_stock != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("detailed_stock", 0);
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{mt: 3}}>
                <Grid size={{xs: 12, md: 8, xl: 6}}>
                  <h3 className={style.htitleText}>
                    How often do you take a physical stock inventory?
                  </h3>
                  <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                      <GlobalTextField
                        type="text"
                        value={formik.values.physical_stock}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="physical_stock"
                        name="physical_stock"
                        error={
                          formik.touched.physical_stock &&
                          Boolean(formik.errors.physical_stock)
                        }
                        helperText={
                          formik.touched.physical_stock &&
                          formik.errors.physical_stock
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{mt: 1}}>
                <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                  <h2 className={style.formTitleh2}>
                    7) Jewelers Security Alliance
                  </h2>
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                  <h3 className={style.htitleText}>
                    Are you a member of the Jewelers Security Alliance?
                  </h3>
                  <Grid container spacing={2} sx={{mt: 2}}>
                    <Grid size={{xs: 12, md: 6}}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.secure_alliance_member == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("secure_alliance_member", 1);
                        }}
                        error={
                          formik.touched.secure_alliance_member &&
                          Boolean(formik.errors.secure_alliance_member)
                        }
                        errorText={
                          formik.touched.secure_alliance_member &&
                          formik.errors.secure_alliance_member
                        }
                      />
                    </Grid>
                    <Grid size={{xs: 12, md: 6}}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.secure_alliance_member != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          //formik.setFieldValue("secure_alliance_member", 0);
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            secure_alliance_member: 0,
                            secure_alliance_member_reason: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {formik.values.secure_alliance_member == 1 ? (
                  <Grid size={{xs: 12, md: 6}}>
                    <h3 className={style.htitleText}>
                      Please specify which ones? *
                    </h3>
                    <Grid container spacing={2}>
                      <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
                        <GlobalTextField
                          type="text"
                          value={formik.values.secure_alliance_member_reason}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          id="secure_alliance_member_reason"
                          name="secure_alliance_member_reason"
                          error={
                            formik.touched.secure_alliance_member_reason &&
                            Boolean(formik.errors.secure_alliance_member_reason)
                          }
                          helperText={
                            formik.touched.secure_alliance_member_reason &&
                            formik.errors.secure_alliance_member_reason
                          }
                          disabled={formik.values?.secure_alliance_member == 0}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>
            </form>
          </Box>
        </motion.div>
        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          nextPage={
            // areRequiredFieldsFilled(formik)

            ((formik.values?.any_losses == 1 &&
              formik.values?.losses?.[0]?.year !== "" &&
              formik.values?.losses?.[0]?.type !== "") ||
              formik.values?.any_losses == 0) &&
            formik.errors &&
            Object.keys(formik.errors)?.length === 0 &&
            formik.values?.physical_stock &&
            formik.values?.physical_stock !== "" &&
            !formik.dirty &&
            propStep2DataMemoize !== null
          }
          //handleSave={handleSave}
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />
      </section>
    </>
  );
};

export default StepTwoForm;
